module.exports = __webpack_public_path__ + "img/Kraftfahrzeug_geländegängig.045907c8.svg";